<template>
  <b-row>
    <b-col cols="12">
      <edit-lease-wizard-vertical />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import EditLeaseWizardVertical from "@/views/forms/components/form-leases/EditLeaseWizardVertical.vue";

export default {
  components: {
    BRow,
    BCol,
    EditLeaseWizardVertical,
    // FormWizardNumber,
    // FormWizardIcon,
    // FormWizardVertical,
    // FormWizardVerticalIcon,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
